import { postOwner } from './reportingClient'

export const VAT_TREATMENTS = [
  ['standard', 'Standard · 20%'], ['reduced', 'Reduced · 5%'], ['zero', 'Zero-rated'],
  ['exempt', 'Exempt'], ['outside_scope', 'Outside scope'],
]
export const emptyVatConfiguration = { registration: '', vat_number: '', effective_date: '', entry_basis: '', default_treatment: '', reason: '' }
export const canPrepareVat = (profile, workshopId) => Boolean(workshopId && profile?.role === 'owner' && profile?.workshop_id === workshopId)

export async function vatRequest(workshopId, operation, fields = {}) {
  const data = await postOwner('workshop-vat', { workshop_id: workshopId, operation, ...fields })
  if (data.activation_enabled !== false || (operation === 'read' && (data.workshop_id !== workshopId || data.version !== 'vat-build1'
    || !Array.isArray(data.history) || !Array.isArray(data.catalogue) || !Array.isArray(data.catalogue_history)))) throw new Error('VAT response could not be verified. Refresh to check the current workshop status.')
  if (operation === 'read' && data.rollout && (data.rollout.workshop_id !== workshopId || !['active', 'scheduled', 'off'].includes(data.rollout.status))) throw new Error('Workshop activation status could not be verified.')
  return data
}

export function vatCommand(form) {
  return { kind: 'configuration', ...form, vat_number: form.registration === 'not_registered' ? '' : form.vat_number.trim(),
    default_treatment: form.registration === 'not_registered' ? 'not_registered' : form.default_treatment }
}

export function vatMoney(minor) {
  return minor == null ? 'Unknown' : new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(minor / 100)
}
